module.exports = __webpack_public_path__ + "static/steam-70f39fbbaeff5a25aa9c33deb1fc2432.jpg";